import React, { useState, useEffect } from 'react'
import { Grid, Alert} from '@deere/fuel-react';
import LinearProgressIndicator from "../../components/LineProgressIndicator";
import { useLocation } from "react-router-dom";
import ActionsCOOReviewSurvey from '../../components/coo/ActionsCOOReviewSurvey';
import { useOktaAuth } from '@okta/okta-react'
import { useUserInfo } from '../../providers/userProvider'
import { getCampaigsByRn } from '../../services/campaign.service';
import { ModalSubmit } from '../../components/ModalSubmit';
import { ModalGeneric } from '../../components/ModalGeneric';
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import SurveyTitle from '../../components/SurveyTitle';
import { isValidRequestNumber, validationRules} from '../../utils/utils';
import COOSectionPage from './COOSectionPage';
import { getAllCountryList} from '../../services/survey.service'; 
import { getCOOResponseById,deleteCOOResponseByResponseId,submitCOOResponse} from '../../services/coo.service'; 
import {COO_RESPONSE_STATUSES,CRS_REQUEST_STATUS_OBJ} from "../../utils/surveyLiterals";
import CooAgreementPopUp from '../../components/modals/CooAgreementPopUp';

export default function ReviewPage() {
    const { t } = useTranslation();
    const history = useHistory();
    const userInfo = useUserInfo();
    const { authState } = useOktaAuth();
    const location = useLocation();
    const [statusSaved, setStatusSaved] = useState(undefined);
    const [survey] = useState(location.state.survey);
    const [assignmentId] = useState(location.state.assignmentId);    
    const [responseId] = useState(location.state.responseId);    
    const [campaignAssigned, setCampaignAssigned] = useState();
    const [containsError, setContainsError] = useState();
    const [countryList, setCountryList]= useState(undefined);   
    const [cooResponse,setCOOResponse] = useState();
    const sections = survey.sections.filter(q => q.active).sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1)
    
    const [showModal, setShowModal] = useState(false);
    const [showValidationModal, setShowValidationModal] = useState(false);
    const [validationMsg, setValidationMsg] = useState("");
    const [showGoToSearchModal, setShowGoToSearchModal]= useState(false);
    const [showAgreement, setshowAgreement] = useState(false);

    useEffect(() => {
        //Getting the campaign related with the assignment
        if (userInfo && assignmentId && isValidRequestNumber(assignmentId) && authState?.accessToken?.accessToken) {
            getCampaigsByRn(assignmentId, authState?.accessToken?.accessToken)
            .then((res) => {
                let errorValidation = validationRules(res, userInfo);
                if (errorValidation) { 
                    setContainsError(errorValidation)
                } else {
                    setCampaignAssigned(res);
                }
            }).catch(error => {
                //Campaign not found
                setContainsError('Campaign was not found,please refresh the page if the error persist contact the support department.')
            })            
        }
        if(responseId && assignmentId && authState?.accessToken?.accessToken){
            getCOOResponseById(responseId, authState?.accessToken?.accessToken)
            .then((res) => {
                setCOOResponse(res);
                const resAssignments = res.assignments ? res.assignments : null;
                let supplierList = resAssignments.map(function(tmpAssignment){
                    return tmpAssignment.supplierNumber;
                })
                setValidationMsg("Are you sure you want to delete this response? \n Response No. " + responseId + " \n Supplier(s):" + supplierList.toString() );                
            }).catch(error => {
                console.log(error)
                setContainsError('Response was not found, please refresh the page if the error persist contact the support department.')
            })
        }  
        if(!countryList && authState?.accessToken?.accessToken){
            getAllCountryList(authState?.accessToken?.accessToken).then(response => {
               if(response){
                 setCountryList(response);
                }
            })
        }    
    }, [assignmentId,responseId,userInfo,authState?.accessToken?.accessToken]);

    const setStatusSubmit = (message) => {
        let statusResponse = { ...message };
        setStatusSaved(statusResponse);
    }

    function handlePrint() {
        window.print();
    }

    const submitResponseFn = () => {
        try {
            
            const responseObject = {id: cooResponse.id,status:COO_RESPONSE_STATUSES.SUBMITTED,updatedBy: userInfo.userID}
            submitCOOResponse(responseObject, authState?.accessToken?.accessToken).then((camp) => {
                setStatusSubmit({ status: true, message: "Response submitted succesfully", label: 'Success:', variant: 'success' });
                setShowModal(false);
                if( camp &&  camp.campaignAssignment && camp.campaignAssignment.length>0 && camp.campaignAssignment[0].status===CRS_REQUEST_STATUS_OBJ.COMPLETE) {                     
                     setShowGoToSearchModal(true)
                   }
                else{ 
                    history.goBack(); 
                }
            })
        } catch (error) {
            console.log(error);
            setStatusSubmit({ status: true, message: error, label: 'Danger:', variant: 'danger' });
            setShowModal(false);
            window.scrollTo(0, 0);
        }
    }

    const handleDeleteResponse = () => {
        try {
            deleteCOOResponseByResponseId(cooResponse.id,authState?.accessToken?.accessToken).then((response) => {
                if(response && response.numberResponsesDeleted && response.numberResponsesDeleted >0){
                    setShowValidationModal(false);
                    history.goBack();
                }else{
                    setStatusSubmit({ status: true, message: 'Error deleting the response, please refresh the page and try again.', label: 'Success:', variant: 'success' });
                    window.scrollTo(0, 0);        
                }
            })
        } catch (error) {
            console.log(error);
            setStatusSubmit({ status: true, message: error, label: 'Danger:', variant: 'danger' });
            window.scrollTo(0, 0);
        }
        return true;
    };

    const handleShowGoToSearchModal= ()=>{
        history.push({
            pathname: '/',
            state: { previous: history.location.pathname }
        })
    }

    const backToEdit = () =>{
        history.goBack();
    }

    return campaignAssigned ?
            (<Grid container>
                <Grid item xs={12}>
                    <SurveyTitle survey={survey} assignment={campaignAssigned.assignments[0]} latestResponse={cooResponse} handlePrint={handlePrint} endDate={campaignAssigned.endDate}/>
                </Grid>
                <Grid item xs={12}>
                    {
                    (statusSaved && statusSaved.status) &&
                        <Alert variant={'success'} title={statusSaved.label}>{statusSaved.message}</Alert>
                    }
                    {
                    containsError &&
                        <Alert variant={'error'} title={'Error'}>{containsError}</Alert>
                    }
                    {                        
                        sections.sort((a,b) => (a.showOrder > b.showOrder)? 1 : -1).map((section,index) =>
                            // (section.showOrder===4)&& 
                            <COOSectionPage key={`section-${section.id}`} review section={section} survey={survey} cooData={{...location.state.cooData}} campaign={campaignAssigned} cooResponses={null} countryList={countryList}
                            />
                        )
                    }
                    {campaignAssigned && <ActionsCOOReviewSurvey setshowAgreement={setshowAgreement} cooResponse={cooResponse} setShowValidation={setShowValidationModal} campaign={campaignAssigned} backToEdit={backToEdit} survey={survey}/>}
                    <CooAgreementPopUp showAgreement={showAgreement} setshowAgreement={setshowAgreement} submitResponse={submitResponseFn}/>
                    <ModalSubmit showModal={showModal} setShowModal = {setShowModal} titleKey={'survey_submit_modal_title'} messageKey={'submit_popup_message'}/>
                    <ModalGeneric showModal={showValidationModal}
                           setShowModal ={setShowValidationModal} 
                           labelBtnPrimary={t('t2_remove')}
                           labelBtnSecondary={t('btn_cancel')}
                           handleSubmit={handleDeleteResponse}
                           msgModal={validationMsg}
                           titleModal={t('t2_remove')}
                    />
                    <ModalSubmit showModal={showGoToSearchModal}
                        setShowModal={setShowGoToSearchModal} 
                        titleKey={'cm_lbl_request_completed_title'}
                        messageKey={'cm_lbl_request_completed_message'}
                        buttonKey={'btn_OK'}
                    />
                </Grid>
            </Grid>
        )      
        : <Grid container>
            <Grid item xs={6} md={12}>
                <LinearProgressIndicator title='Loading' subtitle='This will take a couple of seconds'/>
            </Grid>
        </Grid>
}